/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const algolia = algoliasearch(
    window.consumerAlgoliaApplicationId,
    window.consumerAlgoliaApiKey
);
const index = algolia.initIndex(
    window.consumerAlgoliaIndexName
);
$(function() {
  const searchElement = $('.js-search-query');
  searchElement.autocomplete({
    hint: false,
    minLength: 3,
    cssClasses: {
      root: 'autocomplete-wrapper',
      prefix: 'autocomplete'
    }
  }, [ {
    source: $.fn.autocomplete.sources.hits(index, {hitsPerPage: 5}),
    displayKey: 'name',
    templates: { suggestion(suggestion) {
        const {
          url
        } = suggestion;
        const name = suggestion._highlightResult.display_title.value;
        return '<span><a href=' + url + '>' + name + '</a></span>';
      }
    }

  } ]);

  return searchElement.on('autocomplete:cursorchanged', function(event, suggestion) {}
  ).on('autocomplete:selected', function(event, suggestion) {
    searchElement.autocomplete('val', suggestion.title);
    searchElement.autocomplete('close');
    return event.target.form.submit();
  });
});
